/**
 * @generated SignedSource<<8537225dbdb3f656ce85fc0d4ec98947>>
 * @relayHash 76fcdda26d5cebfbc0bdbfc7500aaba8
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 77cad9e713773fc9731f7546654bb6829a888de63c65c65ad0484a7d7526abb5

import type { ConcreteRequest, Mutation } from 'relay-runtime';
export type JiraUpdateVersionReleaseDateInput = {
  id: string;
  releaseDate?: AGG$DateTime | null | undefined;
};
export type versionDates_updateVersionReleaseDateMutation$variables = {
  input: JiraUpdateVersionReleaseDateInput;
};
export type versionDates_updateVersionReleaseDateMutation$data = {
  readonly jira: {
    readonly updateVersionReleaseDate: {
      readonly success: boolean;
      readonly version: {
        readonly releaseDate: AGG$DateTime | null | undefined;
      } | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type versionDates_updateVersionReleaseDateMutation = {
  response: versionDates_updateVersionReleaseDateMutation$data;
  variables: versionDates_updateVersionReleaseDateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "success"
},
v3 = {
  "kind": "ScalarField",
  "name": "releaseDate"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "versionDates_updateVersionReleaseDateMutation",
    "selections": [
      {
        "concreteType": "JiraMutation",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "concreteType": "JiraUpdateVersionPayload",
            "kind": "LinkedField",
            "name": "updateVersionReleaseDate",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "concreteType": "JiraVersion",
                "kind": "LinkedField",
                "name": "version",
                "plural": false,
                "selections": [
                  (v3/*: any*/)
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "versionDates_updateVersionReleaseDateMutation",
    "selections": [
      {
        "concreteType": "JiraMutation",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "concreteType": "JiraUpdateVersionPayload",
            "kind": "LinkedField",
            "name": "updateVersionReleaseDate",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "concreteType": "JiraVersion",
                "kind": "LinkedField",
                "name": "version",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  {
                    "kind": "ScalarField",
                    "name": "id"
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "77cad9e713773fc9731f7546654bb6829a888de63c65c65ad0484a7d7526abb5",
    "metadata": {},
    "name": "versionDates_updateVersionReleaseDateMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "0404a02cdc80d06adbaaf61ada39552b";

export default node;
